AOS.init();

$(document).ready(function () {


  
  /*Frete Lateral*/

    function limpa_formulário_cep() {
      /*Limpa valores do formulário de cep.*/
      $("#cep-frete").val("");
      $("#pais-frete").val("");
      $("#estado-frete").val("");
    };

    function buscarCEP(inputCEP) {      
      /*Nova variável "cep" somente com dígitos.*/
      var cep = inputCEP.val().replace(/\D/g, '');
      var cepLimpo = inputCEP.val().replace(/\D/g, '');

      /*Verifica se campo cep possui valor informado.*/
      if (cep != "") {

        /*Expressão regular para validar o CEP.*/
        var validacep = /^[0-9]{8}$/;

        /*Valida o formato do CEP.*/
        if(validacep.test(cep)) {

          /*Consulta o webservice viacep.com.br*/
          $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {
            if (!("erro" in dados)) {

              switch(dados.uf){
                case 'AC': dados.uf = 'Acre'; break;
                case 'AL': dados.uf = 'Alagoas'; break;
                case 'AP': dados.uf = 'Amapa'; break;
                case 'AM': dados.uf = 'Amazonas'; break;
                case 'BA': dados.uf = 'Bahia'; break;
                case 'CE': dados.uf = 'Ceara'; break;
                case 'DF': dados.uf = 'Distrito Federal'; break;
                case 'ES': dados.uf = 'Espirito Santo'; break;
                case 'GO': dados.uf = 'Goias'; break;
                case 'MA': dados.uf = 'Maranhao'; break;
                case 'MT': dados.uf = 'Mato Grosso'; break;
                case 'MS': dados.uf = 'Mato Grosso do Sul'; break;
                case 'MG': dados.uf = 'Minas Gerais'; break;
                case 'PA': dados.uf = 'Para'; break;
                case 'PB': dados.uf = 'Paraiba'; break;
                case 'PR': dados.uf = 'Parana'; break;
                case 'PE': dados.uf = 'Pernambuco'; break;
                case 'PI': dados.uf = 'Piaui'; break;
                case 'RJ': dados.uf = 'Rio de Janeiro'; break;
                case 'RN': dados.uf = 'Rio Grande do Norte'; break;
                case 'RS': dados.uf = 'Rio Grande do Sul'; break;
                case 'RO': dados.uf = 'Rondonia'; break;
                case 'RR': dados.uf = 'Roraima'; break;
                case 'SC': dados.uf = 'Santa Catarina'; break;
                case 'SP': dados.uf = 'Sao Paulo'; break;
                case 'SE': dados.uf = 'Sergipe'; break;
                case 'TO': dados.uf = 'Tocantins'; break;
              }; 

              // console.log(dados.uf);

              //Atualiza os campos com os valores da consulta.
              $("#cep-frete").val(dados.cep);
              $("#pais-frete").val("Brazil");
              $("#estado-frete").val(dados.uf);

              var cep = cep,
                  pais = $("#pais-frete").val(),
                  estado = $("#estado-frete").val();

              // console.log(cepLimpo);

              $.ajax({
                type: "GET", //rest Type
                dataType: "json", //mispelled
                url: "/cart/shipping_rates.json?shipping_address%5Bzip%5D="+cepLimpo+"&shipping_address%5Bcountry%5D="+pais+"&shipping_address%5Bprovince%5D="+estado,
                beforeSend: function() {
                  $('.overlay-carregando').show();
                },
                success: function (msg) {

                  if (msg.shipping_rates[0].price == "0.00"){
                    $(".preco-frete").html("Grátis");
                  }else{
                    $(".preco-frete").html("R$ "+msg.shipping_rates[0].price);
                  }

                  $("#fretes-disponiveis").empty();

                  for(i = 0; i < msg.shipping_rates.length; i++) {
                    if (msg.shipping_rates[i].price == "0.00"){
                      $("#fretes-disponiveis").append(new Option(msg.shipping_rates[i].name, [i]));
                    }else{
                      if (msg.shipping_rates[i].delivery_days[1] == "0"){
                        $("#fretes-disponiveis").append(new Option(msg.shipping_rates[i].name+" - R$ "+msg.shipping_rates[i].price, [i]));
                      }else{
                        $("#fretes-disponiveis").append(new Option(msg.shipping_rates[i].name+" - R$ "+msg.shipping_rates[i].price+" ("+msg.shipping_rates[i].delivery_days[1]+" dias úteis)", [i]));
                      }
                    };

                    $("#fretes-disponiveis > option[value='"+[i]+"']").attr("data-valor", msg.shipping_rates[i].price);
                  }             
                  $(".resultado-frete-lateral").show();


                  $('.overlay-carregando').hide();

                  jQuery.getJSON('/cart.js', function(cart) {
                    var subtotal = cart.total_price;
                    var frete = parseInt($('#fretes-disponiveis').find(":selected").data("valor").toString().replace(".", ""));
                    var total = subtotal + frete;

                    $('.label-total-preco').html(
                      Shopify.formatMoney(total, window.money_format)
                    );   

                  });
                  $('.total-carrinho').show();

                  setTimeout(function() {$('#fretes-disponiveis').click();}, 2000);

                },
                error: function(erro) {
                  $(".resultado-frete-lateral").hide();
                  $(".preco-frete").html("--");
                  limpa_formulário_cep();
                  $('.overlay-carregando').hide();
                  $('.total-carrinho').hide();
                }
              });
            } //end if.
            else {
              //CEP pesquisado não foi encontrado.
              limpa_formulário_cep();
              $(".resultado-frete-lateral").hide();
              $(".overlay-carregando").hide();
              alert("CEP não encontrado.");
              $('.total-carrinho').hide();
            }
          });
        } //end if.
        else {
          //cep é inválido.
          limpa_formulário_cep();
          $(".resultado-frete-lateral").hide();
          alert("Formato de CEP inválido.");
          $('.overlay-carregando').hide();
          $('.total-carrinho').hide();
        }
      } /*end if.*/
      else {
        //cep sem valor, limpa formulário.
        limpa_formulário_cep();
      }
    };

    $(document).on('blur', "#cep-frete", function () {
      /*$('.overlay-carregando').show();*/
      buscarCEP($(this));
    });

    $(document).on('keyup', "#cep-frete", function () {
      var numeros = $(this).val().replace(/\D/g, '').length;

      if(numeros == 8){
        $('.overlay-carregando').show();
        setTimeout(function(){$("#cep-frete").blur();}, 500);
      }
    });

    $(document).on('keyup', "#cep-frete", function (event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13'){
        $('.overlay-carregando').show();
        buscarCEP($(this)); 
      }
    });

    $(document).on('change',"#fretes-disponiveis", function() {
      console.log($(this).find(':selected').data('valor'));
      var precoItem = $(this).find(':selected').data('valor');

      if(precoItem != 0.00){
        $(".preco-frete").html("R$ "+precoItem);
      }else{
        $(".preco-frete").html('GRÁTIS');
      }

      jQuery.getJSON('/cart.js', function(cart) {
        var subtotal = cart.total_price;
        var frete = parseInt($('#fretes-disponiveis').find(":selected").attr('data-valor').replace(".", ""));
        var total = subtotal + frete;

        $('.label-total-preco').html(
          Shopify.formatMoney(total, window.money_format)
        );  

      });

      $('.total-carrinho').show();

    });
});
// Fim Frete lateral
